module.exports = __webpack_public_path__ + "files/b2e94cc135651c0b663e24b6923517fe.png";